module.exports = __webpack_public_path__ + "static/media/vehicle-blue.efc29722.svg";